
<template>
<div class="subdomain-form">
  <form class="flex-column" @submit="save">
    <h-input
        label="Subdomain"
        v-model="subDomain.sub_domain"
        @change="objectUpload.sub_domain = subDomain.sub_domain"
        :readonly="!!origSubDomain"
        @keypress="check"
        outline
        required
      />
    <div class="text-info">
      Your full path: <b>https://{{subDomain.sub_domain || "app" }}.habittechnologies.com</b>
    </div>
    <!-- <v-checkbox v-model="subDomain.allow_onboarding" label="Allow public signups" /> -->
    <!-- <div class="text-info" v-if="subDomain.allow_onboarding">
      Clients can sign up at: <b>https://{{subDomain.sub_domain }}.habittechnologies.com/sign-up</b>
    </div> -->
    <!-- <div class="onboarding" v-if="subDomain.allow_onboarding">
      <v-checkbox
        v-model="subDomain.notify_on_onboarded"
        label="Notify me when new clients signup"/>
      <h-select
        outline
        :items="habitPrograms"
        item-value="id"
        item-text="name"
        v-model="subDomain.default_habit_program"
        label="Default Habit Program"
        :required="subDomain.allow_onboarding"></h-select>
      <h-select
         outline
         :items="pulseSurveys"
         item-value="id"
         item-text="name"
         v-model="subDomain.default_pulse_survey"
         label="Default Pulse Survey"></h-select>
    </div> -->
    <!-- <h-input
      class="small-top"
      label="Daily Welcome Message"
      v-model="subDomain.welcome_message"
      @input="objectUpload.welcome_message= subDomain.welcome_message"
      :readonly="!isOwner" /> -->
    <div class="input">
      <label>Header Color</label>
      <swatches style="width: 100%" v-if="subDomain.header_color" :value="subDomain.header_color" @input="color => changeColor(color.hex)" />
    </div>
    <div class="outline">
      <div v-if="logoAlert">
        Logo file size is too large. To ensure fast load times we can only accept logos of less than 300KB.
        Try using a an image compressor. (We recommend <a href="https://tinypng.com/" target="_blank">https://tinypng.com/</a>)
      </div>
      <div class="input row">
        <label>Change Logo</label>
        <input
          type="file"
          :name="uploadFieldName"
          :disabled="isSaving || !isOwner"
          @change="filesChange('logo', 'logoAlert', $event.target.name, $event.target.files); fileCount = $event.target.files.length"
          accept="image/*"
          class="input-file"
          >
      </div>
    </div>
    <div class="small-top">
      <label for="">Logo Size:</label>
      <v-slider
        @change="updateLogo"
        v-model="subDomain.logo_height"
        :disabled="!isOwner"
      ></v-slider>
    </div>


     <div v-if="objectUpload.backgroundAlert">
      Background image file size is too large. To ensure fast load times we can only accept background images of less than 300KB.
      Try using a an image compressor. (We recommend <a href="https://tinypng.com/" target="_blank">https://tinypng.com/</a>)
    </div>
    <div class="input row">

      <span class="row">
      <label>Background Image</label>
      <h-icon v-if="isOwner && objectUpload.background_image" @click="objectUpload.background_image = '/img/beach.jpg'">delete</h-icon>
      </span>
      <input
        type="file"
        :name="uploadFieldName"
        :disabled="isSaving || !isOwner"
        @change="filesChange('background_image', 'backgroundAlert', $event.target.name, $event.target.files)"
        accept="image/*"
        class="input-file"
        >
    </div>
    <slot></slot>
    <div>
      <h-btn color="primary" type="submit" v-if="isOwner" :disabled="isSaving || saving">
        Save
      </h-btn>
    </div>
  </form>
</div>

</template>
<script>
import subHub from "@/services/hubs/subDomain";
import User from "@/services/api/authUser";
import { Swatches } from "vue-color";

export default {
  props: {dontSave: Boolean, saving: Boolean, subDomain: {
    type: Object,
    default: () => { return {header_color: "#ffff"} }
  }},
  components: {
    Swatches
  },
  data() {
    return {
      showPicker: false,
      uploadFieldName: "",
      isSaving: false,
      logoAlert: false,
      objectUpload: { background_image: undefined},
      allow_onboarding: false,
      habitPrograms: [],
      pulseSurveys: [],
      origSubDomain: "",
      backgroundAlert: false 
    };
  },
  created() {
    this.objectUpload = { ...this.subDomain };
    console.log(this.objectUpload)
  },
  methods: {
    check(event) {
      if (!event.key) {
        return;
      }
      const IGNORE_KEY = [
        "enter",
        "tab",
        "delete",
        "escape",
        "left",
        "right",
        "up",
        "down",
        "backspace",
        "arrowleft",
        "arrowright",
        "arrowup",
        "arrowdown"
      ];
      if (IGNORE_KEY.includes(event.key)) {
        return;
      }
      if (!event.key.match(/[a-zA-Z1-9-]/)) {
        event.preventDefault();
      }
    },
    changeColor(color) {
      this.subDomain.header_color = color;
      this.objectUpload.header_color = color;
      subHub.$emit("update", this.subDomain);
    },
    filesChange(field = "logo", error, name, files) {
      if (files.length) {
        let logo = files[0];
        if (logo.size / 1024 > 300) {
          this[error] = true;
          return;
        }
        this[error] = false;
        const reader = new FileReader();
        reader.onload = e => {
          this.subDomain[field] = e.target.result;
          this.objectUpload[field] = e.target.result;
          subHub.$emit("update", this.subDomain);
        };
        // reader.readAsDataURL(logo);
        reader.readAsDataURL(logo);
        // this.objectUpload.logo = logo;
      }
    },
    cancel() {
      this.objectUpload = {};
      this.subDomain = Object.assign({}, this.originalSub);
      subHub.update(this.subDomain);
      this.$emit("canceled");
    },
    updateLogo() {
      this.objectUpload.logo_height = this.subDomain.logo_height;
      subHub.update(this.subDomain);
    },
    save(e) {
      this.objectUpload.sub_domain = this.subDomain.sub_domain;
      let uploadObj = { ...this.objectUpload }
      e.preventDefault();
      if (!uploadObj.background_image || this.objectUpload.background_image === '/img/beach.jpg') {
        delete uploadObj.background_image;
        // uploadObj.background_image = ''
      }
      if (uploadObj.logo && uploadObj.logo.startsWith('https://')) {
        delete uploadObj.logo;
      }
      this.$emit("save", uploadObj);
    }
  },
  computed: {
    isOwner: function() {
      return !this.subDomain.owner || User.id === this.subDomain.owner;
    }
  },
  watch: {
    "objectUpload.background_image": function(newVal) {
      let app = document.getElementById("app");
      app.style.backgroundImage = "url(" + newVal + ")";
    }
  }
};
</script>


<style lang="less">
.subdomain-form {
  .text-info {
    opacity: 0.7;
  }

  form {
    > * {
      padding-top: 10px;
    }
  }
}
</style>
